<template>
  <div class="search-results">
    <h1>Your available events</h1>
    <header>
      <div class="breadcrumbs" v-text="breadcrumbs"></div>
      <button @click="$router.push('/quick-event')">
        <i class="material-icons">edit</i>
      </button>
    </header>
    <main>
      <PlaylistTile v-for="playlist in playlists" :key="playlist.id" :playlist="playlist" />
      
      <p v-if="playlists.length == 0">We have no events with the current parameters.<br>Please <span class="link" @click="$router.go(-1)">change your input</span>.</p>
    </main>

  </div>
</template>

<script>
import PlaylistTile from '@/components/PlaylistTile.vue'

export default {
  name: "SearchResults",
  components: {
    PlaylistTile,
  },
  computed: {
    playlists () {
      return this.$store.getters["scenarioSearch/getResults"]
    },
    breadcrumbs () {
      let filterParams =  this.$store.state.scenarioSearch.filterParams
      return `${filterParams.targetGroup} / ${filterParams.timeValue} min / ${filterParams.topic}`
    }
  }
}
</script>

<style lang="scss" scoped>

h1 {
  font-size: 24px;
  color: #3D3DDE;
  margin: 0 15px;
}
.search-results {
  max-width: var(--container-width);
  margin: 0 auto;
}

header {
  display: flex;
  align-items: center;
  margin: 15px;
  padding-bottom: 15px;
  color: #3D3DDE;
  border-bottom: 2px solid #E2E8FF;

  i {
    color: #3D3DDE;
    font-size: 16px;
  }
}
.breadcrumbs {
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

main {
  padding: 0 15px;
  display: grid;
  grid-template-rows: auto;
  grid-template-columns: 1fr;
  column-gap: 25px;
  row-gap: 35px;

  @media all and (min-width: 700px) {
    grid-template-columns: repeat(2, 1fr);
  }

  p {
    color: #3D3DDE;

    span.link {
      text-decoration: underline;
      cursor: pointer;
    }
  }

  // @media all and (min-width: 1100px) {
  //   grid-template-columns: repeat(3, 1fr);
  // }
}
</style>